module.exports = "/static/assets/fcee2fa04b9ae2811c2bd347df8def5e.png";